/**
 * TCM Backend API — paths from OpenAPI (swagger 2.0).
 * @see openapi (2).yaml
 *
 * Step → endpoint (intended flow):
 * - App load / header: GET list_hospitals
 * - Direct URL entry: GET find_patient/direct/{tablespace}/{athena_patient_id}
 * - Step 1 Patient lookup: GET find_patient/{hospital_id}
 *   (query: patient_name, birth_date; optional: session_id)
 * - Step 3 loading: GET provider_search/{hospital_id}
 *   (query: patient_name, birth_date, expected_discharge_date; optional: patient_id, tablespace, session_id)
 * - Step 5 Summary: POST schedule_appointment/{tablespace}
 *   (body: patient_id, slot_id, physician_id, appointment_type, appointment_notes, hospital_id; optional: session_id)
 */

/** OpenAPI base for list hospitals. Some gateways require trailing slash for GET. */
const LIST_HOSPITALS_RAW =
  import.meta.env.VITE_LIST_HOSPITALS_PATH?.trim() || '/api/v1/list_hospitals'

export function getListHospitalsPaths(): [string, string] {
  const withSlash = LIST_HOSPITALS_RAW.endsWith('/')
    ? LIST_HOSPITALS_RAW
    : `${LIST_HOSPITALS_RAW}/`
  const withoutSlash = LIST_HOSPITALS_RAW.endsWith('/')
    ? LIST_HOSPITALS_RAW.slice(0, -1)
    : LIST_HOSPITALS_RAW
  // Prefer trailing-slash first to avoid initial 405 on gateway variants.
  return [withSlash, withoutSlash]
}

export function pathFindPatient(hospitalId: string): string {
  return `/api/v1/find_patient/find_patient/${encodeURIComponent(hospitalId)}`
}

export function pathDirectPatient(
  tablespace: string,
  athenaPatientId: string,
): string {
  return `/api/v1/find_patient/direct/${encodeURIComponent(tablespace)}/${encodeURIComponent(athenaPatientId)}`
}

export function pathProviderSearch(hospitalId: string): string {
  return `/api/v1/provider_search/provider_search/${encodeURIComponent(hospitalId)}`
}

export function pathScheduleAppointment(tablespace: string): string {
  return `/api/v1/schedule_appointment/schedule_appointment/${encodeURIComponent(tablespace)}`
}

export function pathEncounterOutcome(hospitalId: string): string {
  return `/api/v1/encounter_outcome/encounter_outcome/${encodeURIComponent(hospitalId)}`
}

export function pathSelectedPcp(hospitalId: string): string {
  return `/api/v1/selected_pcp/selected_pcp/${encodeURIComponent(hospitalId)}`
}
